import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lixiang",
  "use": "icon-lixiang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lixiang\"><defs><style type=\"text/css\"></style></defs><path d=\"M875.2 67.7H150.8c-47.5 0-86.1 38.6-86.1 86.1v531.6c0 47.5 38.6 86.1 86.1 86.1h148c19.9 0 36-16.1 36-36s-16.1-36-36-36h-148c-7.6 0-14.1-6.5-14.1-14.1V153.8c0-7.6 6.5-14.1 14.1-14.1h724.4c7.6 0 14.1 6.5 14.1 14.1v531.6c0 7.6-6.5 14.1-14.1 14.1h-148c-19.9 0-36 16.1-36 36s16.1 36 36 36h148c47.5 0 86.1-38.6 86.1-86.1V153.8c0-47.5-38.6-86.1-86.1-86.1z\" p-id=\"2963\" /><path d=\"M630.6 619c-14-14-36.9-14-50.9 0l-70.2 70.2-70.1-70.2c-14-14-36.9-14-50.9 0s-14 36.9 0 50.9l70.2 70.2-70.2 70.2c-14 14-14 36.9 0 50.9s36.9 14 50.9 0l70.2-70.2 70.2 70.2c14 14 36.9 14 50.9 0s14-36.9 0-50.9l-70.2-70.2 70.2-70.2c13.9-14 13.9-36.9-0.1-50.9z\" p-id=\"2964\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/lixiang.svg
// module id = neIx
// module chunks = 5